module.exports = __webpack_public_path__ + "img/moncaliericitta.768ea6a4.png";